import {
  JiraFieldSetViewAriResourceOwner,
  JiraFieldSetViewAriResourceType
} from "./chunk-2NHJYARG.mjs";
import {
  RegisteredAri
} from "./chunk-AB4PPISI.mjs";
import {
  AriParser
} from "./chunk-S7RIZVFI.mjs";

// src/jira/field-set-view/manifest.ts
var jiraFieldSetViewAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: JiraFieldSetViewAriResourceOwner,
  resourceType: JiraFieldSetViewAriResourceType,
  resourceIdSlug: "activation/{activationId}/{fieldSetViewId}",
  resourceIdSegmentFormats: {
    activationId: /[a-zA-Z0-9\-]+/,
    // eslint-disable-line no-useless-escape
    fieldSetViewId: /[0-9]+/
    // eslint-disable-line no-useless-escape
  }
};

// src/jira/field-set-view/index.ts
var JiraFieldSetViewAri = class _JiraFieldSetViewAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldSetViewId = opts.resourceIdSegmentValues.fieldSetViewId;
  }
  get siteId() {
    return this._siteId;
  }
  get activationId() {
    return this._activationId;
  }
  get fieldSetViewId() {
    return this._fieldSetViewId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: jiraFieldSetViewAriStaticOpts.qualifier,
      platformQualifier: jiraFieldSetViewAriStaticOpts.platformQualifier,
      cloudId: opts.siteId,
      resourceOwner: jiraFieldSetViewAriStaticOpts.resourceOwner,
      resourceType: jiraFieldSetViewAriStaticOpts.resourceType,
      resourceId: `activation/${opts.activationId}/${opts.fieldSetViewId}`,
      resourceIdSegmentValues: {
        activationId: opts.activationId,
        fieldSetViewId: opts.fieldSetViewId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, jiraFieldSetViewAriStaticOpts);
    return new _JiraFieldSetViewAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, jiraFieldSetViewAriStaticOpts);
    return new _JiraFieldSetViewAri(opts);
  }
  getVariables() {
    return {
      siteId: this.siteId,
      activationId: this.activationId,
      fieldSetViewId: this.fieldSetViewId
    };
  }
};

export {
  JiraFieldSetViewAri
};
